"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var FlagTV = function FlagTV(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "411.6",
    height: "270.36",
    viewBox: "0 0 411.6 270.36"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M209.54,146.36H-185.94A7.07,7.07,0,0,1-193,139.3V-114.94a7.06,7.06,0,0,1,7.06-7.06H209.54a7.06,7.06,0,0,1,7.06,7.06V139.3a7.06,7.06,0,0,1-7.06,7.06Zm0,0",
    transform: "translate(194 123)",
    fill: "#82afff"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M4.74,12.18H-185.94A7.06,7.06,0,0,1-193,5.12V-114.94a7.06,7.06,0,0,1,7.06-7.06H4.74a7.06,7.06,0,0,1,7.06,7.06V5.12a7.06,7.06,0,0,1-7.06,7.06Zm0,0",
    transform: "translate(194 123)",
    fill: "#41479b"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M4.74-122H-7.53L-72.95-79.14V-122h-35.31v42.86L-173.67-122h-12.27a7.06,7.06,0,0,0-7.06,7.06v5.6l56.12,36.77H-193v35.32h56.12L-193-.49V5.12a7.06,7.06,0,0,0,7.06,7.06h12.27l65.42-42.86V12.18h35.3V-30.68L-7.53,12.18H4.74A7.06,7.06,0,0,0,11.8,5.12V-.49L-44.32-37.25H11.8V-72.57H-44.32L11.8-109.34v-5.6A7.06,7.06,0,0,0,4.74-122Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M11.8-65.5H-80V-122h-21.18v56.5H-193v21.18h91.81v56.5H-80v-56.5H11.8Zm0,0",
    transform: "translate(194 123)",
    fill: "#ff4b55"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-115.32-72.57l-74.31-48.24a7,7,0,0,0-3.37,5.87v.37l64.71,42Zm0,0",
    transform: "translate(194 123)",
    fill: "#ff4b55"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-60-72.57l70.7-45.89a7,7,0,0,0-6-3.54H3.21L-72.95-72.57Zm0,0",
    transform: "translate(194 123)",
    fill: "#ff4b55"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-121.42-37.25-192,8.55a7,7,0,0,0,6,3.63h1.33l76.16-49.43Zm0,0",
    transform: "translate(194 123)",
    fill: "#ff4b55"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M11.69,5.67-54.45-37.25h-13L7.68,11.49a7,7,0,0,0,4-5.82Zm0,0",
    transform: "translate(194 123)",
    fill: "#ff4b55"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-18.07,90.07l-3.78,11.34-11.95.09a1.19,1.19,0,0,0-.7,2.15l9.62,7.1-3.61,11.39a1.19,1.19,0,0,0,1.83,1.33l9.73-7,9.71,7a1.2,1.2,0,0,0,1.84-1.33L-9,110.75l9.61-7.1a1.19,1.19,0,0,0-.69-2.15L-12,101.41l-3.79-11.34a1.19,1.19,0,0,0-2.26,0Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffe15a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M166,1.79l-3.78,11.34-12,.09a1.2,1.2,0,0,0-.7,2.16l9.61,7.09-3.6,11.4a1.19,1.19,0,0,0,1.83,1.32l9.72-6.94,9.72,6.94a1.19,1.19,0,0,0,1.83-1.32l-3.6-11.4,9.61-7.09a1.2,1.2,0,0,0-.7-2.16L172,13.13,168.25,1.79a1.19,1.19,0,0,0-2.26,0Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffe15a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M166-93.54l-3.78,11.33-12,.1a1.18,1.18,0,0,0-.7,2.14l9.61,7.11-3.6,11.39a1.19,1.19,0,0,0,1.83,1.33l9.72-7,9.72,7a1.19,1.19,0,0,0,1.83-1.33l-3.6-11.39L184.68-80a1.18,1.18,0,0,0-.7-2.14L172-82.21l-3.78-11.33a1.19,1.19,0,0,0-2.26,0Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffe15a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M29.25,30.43,33,41.79,23.45,49a1.19,1.19,0,0,0,.72,2.14l11.95,0L40,62.38a1.19,1.19,0,0,0,2.26,0L46,51l11.94-.23a1.19,1.19,0,0,0,.68-2.16l-9.7-7,3.48-11.43a1.19,1.19,0,0,0-1.84-1.31l-9.65,7.06-9.79-6.84a1.19,1.19,0,0,0-1.82,1.35Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffe15a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M28.37,79.43,32.1,90.78,22.57,98a1.19,1.19,0,0,0,.72,2.14l12,0,3.9,11.29a1.2,1.2,0,0,0,2.27,0L45.06,100,57,99.75a1.19,1.19,0,0,0,.67-2.16L48,90.6l3.48-11.44a1.2,1.2,0,0,0-1.85-1.31L40,84.91l-9.8-6.84a1.19,1.19,0,0,0-1.81,1.36Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffe15a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M80,67.07l3.73,11.35-9.53,7.2a1.19,1.19,0,0,0,.72,2.15l11.95,0L90.79,99a1.19,1.19,0,0,0,2.26,0L96.7,87.61l12-.22a1.19,1.19,0,0,0,.67-2.16l-9.69-7,3.48-11.44a1.19,1.19,0,0,0-1.84-1.3l-9.65,7-9.8-6.84A1.19,1.19,0,0,0,80,67.07Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffe15a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M79.12-39.75,82.86-28.4l-9.54,7.21A1.19,1.19,0,0,0,74.05-19l12,0L89.91-7.8a1.19,1.19,0,0,0,2.26,0L95.82-19.2l12-.23a1.19,1.19,0,0,0,.67-2.16l-9.69-7L102.23-40a1.2,1.2,0,0,0-1.85-1.31l-9.64,7.06-9.8-6.84a1.2,1.2,0,0,0-1.82,1.35Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffe15a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M122.82-54.31,126.55-43,117-35.75a1.19,1.19,0,0,0,.73,2.14l11.95,0,3.9,11.29a1.19,1.19,0,0,0,2.26,0l3.66-11.38L151.46-34a1.19,1.19,0,0,0,.68-2.16l-9.69-7,3.47-11.43a1.19,1.19,0,0,0-1.84-1.31l-9.64,7.06-9.8-6.84a1.19,1.19,0,0,0-1.82,1.35Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffe15a"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "1",
    y: "1",
    width: "409.6",
    height: "268.36",
    rx: "7",
    ry: "7",
    fill: "none"
  }));
};

var _default = FlagTV;
exports["default"] = _default;